export default function Footer() {
  return (
    <footer style={{ borderTop: "1px solid var(--rule)", background: "var(--ground)" }} data-testid="app-footer">
      <div
        className="wrap"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
          paddingBlock: 28,
          fontSize: 14,
          color: "var(--muted)",
        }}
      >
        <span style={{ fontFamily: "var(--serif)", fontSize: 18, color: "var(--ink)" }}>
          Jarvis <em>Editorial</em>
        </span>
        <nav aria-label="Pie" style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
          <a href="#como" style={{ color: "var(--muted)" }}>Cómo funciona</a>
          <a href="#precios" style={{ color: "var(--muted)" }}>Precios</a>
          <a href="#faq" style={{ color: "var(--muted)" }}>Preguntas</a>
        </nav>
        <span>Jarvis Editorial · en español</span>
      </div>
    </footer>
  );
}
